<template>
  <div class="quizset-button-delete" @click="remove">
    クイズセットの削除
  </div>
</template>

<script>
export default {
  methods: {
    remove: function () {
      if (window.confirm('本当に削除しますか？')) {
        this.$router.go(-1)
        this.$store.dispatch('quizset/deleteQuizset')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quizset-button-delete {
  @include button-ol-danger;
}
</style>
